import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

import { DASHBOARD_ACCESS } from 'src/auth/permission-access';

const icon = (name) => <Iconify icon={`solar:${name}-bold-duotone`} width={24} />;

const ICONS = {
  profile: icon('user-circle'),
  organization: icon('buildings-2'),
  dashboard: icon('widget-5'),
  map: icon('map'),
  fleetMap: icon('map-point-wave'),
  devices: icon('gps'),
  profiles: icon('layers-minimalistic'),
  reports: icon('chart-square'),
  access: icon('users-group-rounded'),
  security: icon('shield-keyhole'),
  geography: icon('map'),
  about: icon('info-circle'),
};

export const navData = [
  {
    key: 'daily',
    subheader: 'روزانه',
    defaultOpen: true,
    items: [
      { title: 'داشبورد', path: paths.dashboard.root, icon: ICONS.dashboard },
      {
        title: 'مسیریابی',
        path: paths.dashboard.mapUi,
        icon: ICONS.map,
        access: DASHBOARD_ACCESS.map,
      },
      {
        title: 'نقشه ناوگان',
        path: paths.dashboard.map,
        icon: ICONS.fleetMap,
        access: DASHBOARD_ACCESS.map,
      },
      {
        title: 'دستگاه‌ها و داده‌ها',
        path: paths.dashboard.devices,
        icon: ICONS.devices,
        children: [
          {
            title: 'مدیریت دستگاه‌ها',
            path: paths.dashboard.devices,
            access: DASHBOARD_ACCESS.devices,
          },
          {
            title: 'پروفایل‌های دستگاه',
            path: paths.dashboard.deviceProfiles,
            access: DASHBOARD_ACCESS.deviceProfiles,
          },
          {
            title: 'گروه‌های ناوگان',
            path: paths.dashboard.fleetGroups,
            access: DASHBOARD_ACCESS.fleetGroups,
          },
          {
            title: 'حصارهای جغرافیایی',
            path: paths.dashboard.geofences,
            access: DASHBOARD_ACCESS.geofences,
          },
          {
            title: 'مدیریت اعلان‌ها',
            path: paths.dashboard.alertRules,
            access: DASHBOARD_ACCESS.alertRules,
          },
        ],
      },
      {
        title: 'گزارش‌ها',
        path: paths.dashboard.routeReport,
        icon: ICONS.reports,
        access: DASHBOARD_ACCESS.routeReport,
        children: [
          {
            title: 'گزارش مسیر تردد',
            path: paths.dashboard.routeReport,
            access: DASHBOARD_ACCESS.routeReport,
          },
          {
            title: 'گزارش خلاصه تردد',
            path: paths.dashboard.routeSummary,
            access: DASHBOARD_ACCESS.routeReport,
          },
        ],
      },
    ],
  },
  {
    key: 'organization',
    subheader: 'سازمان و دسترسی',
    defaultOpen: true,
    items: [
      {
        title: 'سازمان',
        path: paths.dashboard.organization,
        icon: ICONS.organization,
        children: [
          {
            title: 'تنظیمات سازمان',
            path: paths.dashboard.organization,
            access: DASHBOARD_ACCESS.organization,
          },
        ],
      },
      {
        title: 'کاربران و مجوزها',
        path: paths.dashboard.members,
        icon: ICONS.access,
        children: [
          {
            title: 'کاربران سازمان',
            path: paths.dashboard.members,
            access: DASHBOARD_ACCESS.members,
          },
          {
            title: 'دعوت کاربران',
            path: paths.dashboard.invitations,
            access: DASHBOARD_ACCESS.invitations,
          },
          {
            title: 'نقش‌ها و مجوزها',
            path: paths.dashboard.roles,
            access: DASHBOARD_ACCESS.roles,
          },
          {
            title: 'همه کاربران سامانه',
            path: paths.dashboard.systemAccess,
            access: DASHBOARD_ACCESS.systemAccess,
          },
        ],
      },
    ],
  },
  {
    key: 'platform',
    subheader: 'مدیریت سامانه',
    defaultOpen: true,
    items: [
      {
        title: 'امنیت و تاریخچه فعالیت‌ها',
        path: paths.dashboard.securitySettings,
        icon: ICONS.security,
        children: [
          {
            title: 'امنیت و ورود',
            path: paths.dashboard.securitySettings,
            access: DASHBOARD_ACCESS.securitySettings,
          },
          {
            title: 'تاریخچه فعالیت‌ها',
            path: paths.dashboard.audit,
            access: DASHBOARD_ACCESS.audit,
          },
        ],
      },
      {
        title: 'کدینگ پایه سامانه',
        path: paths.dashboard.geographyCodings,
        icon: ICONS.geography,
        children: [
          {
            title: 'مناطق جغرافیایی',
            path: paths.dashboard.geographyCodings,
            access: DASHBOARD_ACCESS.geographyCodings,
          },
        ],
      },
    ],
  },
  {
    key: 'account',
    subheader: 'حساب کاربری',
    defaultOpen: true,
    items: [{ title: 'پروفایل من', path: paths.dashboard.profile, icon: ICONS.profile }],
  },
  // اطلاعات عمومی نرم‌افزار همیشه آخرین گزینه منو است و مجوز مدیریتی نمی‌خواهد.
  {
    key: 'about',
    items: [{ title: 'درباره ما', path: paths.dashboard.about, icon: ICONS.about }],
  },
];
